export const convertListToObjectsArray = (list: string[]) => {
    return list?.map((item: string) => {
        return {
            value: item,
            label: item,
        };
    });
};
